import styled, { css } from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

const paddingStyle = css`
  padding: 16px;
`

export const ModalOverlay = styled.div`
  z-index: 999;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-around;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  overflow: hidden;
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: fixed;
  max-width: ${({ maxWidth }) => maxWidth}px;
  border-radius: 3px;
  color: ${getToken('color-neutral-darkest')};
  background-color: ${getToken('color-neutral-lightest')};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
  overflow-x: hidden;
  overflow-y: auto;

  ${screen.md} {
    height: auto;
    position: relative;
    width: ${({ alwaysFull }) => (alwaysFull ? '100%' : 'auto')};
  }

  ${screen.lg} {
    height: ${({ height }) => (height ? `${height}px` : 'auto')};
  }
`

export const ModalHeader = styled.div`
  ${paddingStyle}
  color: ${getToken('color-neutral-darkest')};
  background-color: ${getToken('color-neutral-white')};
  border-bottom: 1px solid ${getToken('color-neutral-lighter')};
  text-align: center;
  font-weight: bold;
`

export const ModalBody = styled.div`
  ${paddingStyle}
  background-color: ${getToken('color-neutral-lightest')};
  height: 100%;
`
